function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 10H82C84.2091 10 86 11.7909 86 14V58H26V10Z",
  fill: "#D8DDEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 14C11 11.7909 12.7909 10 15 10H62C64.2091 10 66 11.7909 66 14V58H11V14Z",
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 54,
  width: 100,
  height: 4,
  rx: 2,
  fill: "#F5F8FA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 25,
  width: 24,
  height: 14,
  rx: 4,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 28,
  width: 4,
  height: 8,
  rx: 2,
  fill: "#D8DDEB"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88 24C94.6275 24 100 18.6275 100 12C100 5.37258 94.6275 0 88 0C81.3726 0 76 5.37258 76 12C76 18.6275 81.3726 24 88 24ZM89.5 6C89.5 5.17158 88.8285 4.5 88 4.5C87.1716 4.5 86.5 5.17158 86.5 6V12C86.5 12.3978 86.658 12.7794 86.9393 13.0606L91.1819 17.3032C91.7677 17.8891 92.7175 17.8891 93.3032 17.3032C93.8891 16.7175 93.8891 15.7677 93.3032 15.1819L89.5 11.3787V6Z",
  fill: "url(#paint0_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 64,
  y1: 12,
  x2: 88,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgPackageWithWaitingClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 58,
    viewBox: "0 0 100 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = React.forwardRef(SvgPackageWithWaitingClock);
export default __webpack_public_path__ + "static/media/package-with-waiting-clock.ba058cac.svg";
export { ForwardRef as ReactComponent };